import React from 'react';
import styled from 'styled-components';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { motion } from 'framer-motion';

const SearchContainer = styled.div`
  display: flex;
  max-width: 500px;
  margin: 20px auto 30px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 30px;
  padding: 5px;
  border: 1px solid rgba(75, 192, 192, 0.2);
  position: relative;
  
  &:focus-within {
    box-shadow: 0 0 0 2px rgba(75, 192, 192, 0.3);
  }
`;

const Input = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  padding: 10px 15px;
  color: white;
  font-size: 16px;
  outline: none;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px;
  color: rgba(75, 192, 192, 0.8);
`;

const ClearButton = styled(motion.button)`
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`;

/**
 * Reusable search input component with animation
 * 
 * @param {Object} props
 * @param {string} props.value - Current search term
 * @param {Function} props.onChange - Function to handle input change
 * @param {Function} props.onClear - Function to clear the search
 * @param {string} props.placeholder - Placeholder text
 */
const SearchInput = ({ 
  value = '', 
  onChange, 
  onClear, 
  placeholder = 'Search...' 
}) => {
  return (
    <SearchContainer>
      <IconWrapper>
        <FaSearch />
      </IconWrapper>
      
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      
      {value && (
        <ClearButton
          onClick={onClear}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaTimes />
        </ClearButton>
      )}
    </SearchContainer>
  );
};

export default SearchInput;
